import { Style, StyleGarment } from './styleTypes';

interface CoverageFromStyle {
  isBottomDisabled: boolean;
  isTopDisabled: boolean;
}

/**
 * Get all available sizes.
 * @param style Style.
 */
export const filterStyleSizes = (style: Style): string[] => {
  const set = new Set(style.variants.map(g => g.size));
  const arr = Array.from(set);
  return arr;
};

/**
 * Get all available variants.
 * @param style Style.
 */
export const filterStyleVariants = (style: Style): StyleGarment[] => {
  const masters = style.variants.reduce((masters, g) => {
    const index = masters.findIndex(m => m.variant === g.variant);

    if (index === -1) {
      masters.push(g);
    } else {
      // compare priorities and substitute if needed
      const master = masters[index];
      if (master.priority < g.priority) {
        masters.splice(index, 1, g);
      }
    }

    return masters;
  }, [] as StyleGarment[]);

  return masters;
};

/**
 * Filter available sizes from variant.
 * @param style Style.
 * @param variant Variant name.
 */
export const filterStyleSizesFromVariant = (style: Style, variant: string): string[] => {
  const { variants } = style;
  const sizes = variants.filter(v => v.variant === variant).map(v => v.size);
  return sizes;
};

/**
 * Find garment from size and variant.
 * @param style Style.
 * @param variant Variant name.
 */
export const findStyleGarment = (
  style: Style,
  size: string,
  variant: string,
): StyleGarment | undefined => {
  return style.variants.find(g => g.size === size && g.variant === variant);
};

/**
 * Find garment from variant.
 * @param style Style.
 * @param variant Variant name.
 */
export const findStyleGarmentMaster = (style: Style, variant: string): StyleGarment | undefined => {
  return style.variants.find(g => g.variant === variant);
};

/**
 * Get style avatar coverage.
 * @param style Style.
 */
export const getStyleAvatarCoverage = (style: Style): CoverageFromStyle => {
  const type = style.type0;

  let isBottomDisabled = false;
  let isTopDisabled = false;

  switch (type) {
    case 'TOP':
      isTopDisabled = true;
      break;
    case 'BOTTOM':
      isBottomDisabled = true;
      break;
    case 'FULL_BODY':
      isBottomDisabled = true;
      isTopDisabled = true;
      break;
    default:
      break;
  }

  return { isBottomDisabled, isTopDisabled };
};
